import { render } from "./MyOrderLegs.vue?vue&type=template&id=eabad1fa"
import script from "./MyOrderLegs.vue?vue&type=script&lang=js"
export * from "./MyOrderLegs.vue?vue&type=script&lang=js"

import "./MyOrderLegs.vue?vue&type=style&index=0&id=eabad1fa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__